import { render, staticRenderFns } from "./Pharma.vue?vue&type=template&id=5ef78529&scoped=true"
import script from "./Pharma.vue?vue&type=script&lang=js"
export * from "./Pharma.vue?vue&type=script&lang=js"
import style0 from "./Pharma.vue?vue&type=style&index=0&id=5ef78529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef78529",
  null
  
)

export default component.exports